import { render, staticRenderFns } from "./Account_another.vue?vue&type=template&id=435771a8&"
import script from "./Account_another.vue?vue&type=script&lang=js&"
export * from "./Account_another.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports